import { DataTable } from "primereact/datatable";
import Loader from "./Loader";
import { useTranslation } from "react-i18next";
import React from "react";

// const rowsPerPageOptions = [10, 25];
const itemsPerPage = 10;

const ReusableDataTable = ({
  tableData,
  currentPage,
  totalRecords,
  isLoading,
  isFetching,
  sorting,
  searchQuery,
  setSorting,
  setCurrentPage,
  initialSorting,
  children, // for columns
}) => {
  const { t } = useTranslation();
  const dt = React.useRef();

  const handlePageChange = (event) => {
    setCurrentPage(event.page + 1);
  };

  const handleSorting = (event) => {
    if (event.sortOrder !== 0) {
      setSorting({
        sortBy: event.sortField,
        sortOrder: event.sortOrder,
      });
    } else {
      setSorting(initialSorting);
    }
    setCurrentPage(1); // Reset to first page when sorting
  };
  return (
    <DataTable
      value={tableData}
      paginator
      lazy
      first={(currentPage - 1) * itemsPerPage}
      rows={itemsPerPage}
      // rowsPerPageOptions={rowsPerPageOptions}
      totalRecords={totalRecords}
      onPage={handlePageChange}
      loading={isLoading || isFetching}
      loadingIcon={<Loader />}
      onSort={handleSorting}
      sortField={sorting.sortBy}
      sortOrder={sorting.sortOrder}
      ref={dt}
      size="small"
      showGridlines
      stripedRows
      removableSort
      emptyMessage={
        <div className="text-start">
          {searchQuery
            ? t("noSearchResults", { query: searchQuery }) ||
            `No results found for "${searchQuery}"`
            : t("noData") || "No data available"
          }
        </div>
      }
    >
      {children}
    </DataTable>
  );
};

export default ReusableDataTable;
